import { render, staticRenderFns } from "./AgentAnnuityPriceForm.vue?vue&type=template&id=729b0a98&"
import script from "./AgentAnnuityPriceForm.vue?vue&type=script&lang=js&"
export * from "./AgentAnnuityPriceForm.vue?vue&type=script&lang=js&"
import style0 from "./AgentAnnuityPriceForm.vue?vue&type=style&index=0&id=729b0a98&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports